// owned
// eslint-disable-next-line no-unused-vars
import LogFactory from './log-factory.js'

/**
 * A interface that All Provider module must export
 * @interface
 */
export default class Provider {
  /**
   * Checks if a value resembles a logging provider by verifying it has required methods.
   * @param {*} value - The value to check
   * @returns {boolean}
   */
  static isProviderLike (value) {
    if (value == null) {
      return false
    }
    return typeof value === 'object' && typeof value.createLogFactory === 'function' && typeof value.getType === 'function'
  }

  /**
   * Asserts that the given value is a valid provider-like object.
   * @throws {Error} Throws an error if the value is not provider-like.
   * @param {*} value - The value to check.
   */
  static assertProviderLike (value) {
    if (!this.isProviderLike(value)) {
      throw new Error('Not LogProvider')
    }
  }

  /**
   * The Type Name of current Provider
   * @return {String} The type of the provider.
   */
  getType () {
    throw new Error('Not Impled Yet')
  }

  /**
   * Create a new LogFactory instance
   * @param {*} [nativeLib] - The native library to use for logging.
   * @param {*} [setting] - Configuration settings for the logging provider.
   * @returns {LogFactory} A new instance of LogFactory.
   */
  createLogFactory (nativeLib, setting) {
    throw new Error('Not Impled Yet')
  }
}
